import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: [
      {
        name: "default",
        light: {
          primary: "#1976d2"
        }
      },
      {
        name: "agents",
        light: {
          primary: "#4737a4"
        }
      },
      {
        name: "p2p",
        light: {
          primary: "#ff6c93"
        }
      },
      {
        name: "tragents",
        light: {
          primary: "#de3a62"
        }
      },
      {
        name: "dh_p2p",
        light: {
          primary: "#509e2f"
        }
      },
      {
        name: "usa",
        light: {
          primary: "#B31942"
        }
      },
      {
        name: "usaagents",
        light: {
          primary: "#f1095a"
        }
      }
    ]
  }
});
